import type { TaskRow } from '../api/tasks';

const RIED_SLUG = 'ried';

function roleMatchesRied(value: unknown): boolean {
  return String(value ?? '')
    .trim()
    .toLowerCase() === RIED_SLUG;
}

/**
 * True when the viewer has the **ried** role (exact match, case-insensitive).
 * Optionally checks deprecated single `role` from stored auth.
 */
export function userHasRiedRole(
  roles: readonly string[] | undefined | null,
  legacySingleRole?: string | null
): boolean {
  if (legacySingleRole != null && roleMatchesRied(legacySingleRole)) return true;
  if (!Array.isArray(roles) || roles.length === 0) return false;
  return roles.some((r) => roleMatchesRied(r));
}

/** Priority shown in UI for the current user: Ried override when set, else task priority. */
export function displayTaskPriority(task: TaskRow, hasRiedRole: boolean): string | null {
  if (hasRiedRole && task.ried_priority && String(task.ried_priority).trim() !== '') {
    return String(task.ried_priority).trim();
  }
  return task.priority ?? null;
}
